const DEFAULT_REDIRECT = '/home';

/**
 * Accept only application-local paths for post-login navigation.
 *
 * React Router normally keeps navigation inside the SPA, but the redirect
 * value is supplied by the URL. Validating it here prevents future routing
 * changes from turning that value into an open redirect.
 */
export const getSafeInternalRedirect = (
  redirect: string | null | undefined,
  fallback = DEFAULT_REDIRECT,
): string => {
  if (!redirect) return fallback;

  const candidate = redirect.trim();
  const containsControlCharacter = Array.from(candidate).some((character) => {
    const codePoint = character.charCodeAt(0);
    return codePoint <= 31 || codePoint === 127;
  });
  if (
    !candidate.startsWith('/') ||
    candidate.startsWith('//') ||
    candidate.includes('\\') ||
    containsControlCharacter
  ) {
    return fallback;
  }

  return candidate;
};
